<template>
  <div class="system-form-item-fields">
    <w-editor
      v-model="modulesItem.fieldValue"
      @blur="handleChange"
      :isTask="isTask"
      :configs="{
        height: 300,
        editorConfig: {
          placeholder: isQuoteField ? quoteFieldPlaceholder : modulesItem?.placeholder || '',
          readOnly: isQuoteField || modulesItem.businessData == '0' || disabledAll
        }
      }"
    ></w-editor>
  </div>
</template>

<script setup>
import { ref, inject } from 'vue';
const emits = defineEmits(['cb']);
const isQuoteField = inject('fhFormFieldsParams')?.isQuoteField;
const quoteFieldPlaceholder = inject('fhFormFieldsParams')?.quoteFieldPlaceholder;

const props = defineProps({
  modules: {
    type: Object,
    default: () => {}
  },
  isTask: {
    type: Boolean,
    default: false
  },
  disabledAll: {
    type: Boolean,
    default: false
  }
});

const modulesItem = ref(props?.modules);
const handleChange = () => {
  emits('cb', modulesItem.value);
};
</script>
